export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref10113.15330fee.jpg";